import { render } from "./ChoixComponent.vue?vue&type=template&id=43be7ae3"
import script from "./ChoixComponent.vue?vue&type=script&lang=js"
export * from "./ChoixComponent.vue?vue&type=script&lang=js"

import "./ChoixComponent.vue?vue&type=style&index=0&id=43be7ae3&lang=css"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__